import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidates|Details|';

export type CandidateNavCardLocNames =
	| 'SPCandidateNavCardIconLabelRestricted'
	| 'SPCandidateNavCardContentPermanentStatus';

export const spCandidateNavCardLocs: LocDefs<CandidateNavCardLocNames> = {
	SPCandidateNavCardIconLabelRestricted: {
		defaultValue: 'Testing Restricted',
		displayType: 'Label',
		description:
			'Label for the icon on the candidate nav card when the candidate testing is restricted',
		displayPath: `${dpRoot}Testing Restricted Label`,
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.ExamTestCenterRestriction,
		portal: 'SP',
	},
	SPCandidateNavCardContentPermanentStatus: {
		defaultValue: 'Permanent',
		displayType: 'Content',
		description: 'Text displayed when the status is permanent',
		displayPath: `${dpRoot}Permanent`,
		htmlAllowed: false,
		shared: false,
		feature: HubFeature.CandidateProfile,
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<CandidateNavCardLocNames>(spCandidateNavCardLocs);
